import React from 'react';
import {BasePlayersList} from './index';
import FlexRankPlayerPoints from 'components/molecules/player-points/flex-rank-player-points';
import PlayerLockByMode from 'components/molecules/player-lock/player-lock-by-mode';
import PlayerRank from 'components/molecules/player-rank';
import Const from 'constants';
import PlayerExposure from 'components/molecules/player-exposure';
import GeneralExposure from 'components/molecules/player-exposure/general-exposure';
import FlexRankPlayerSympathy from 'components/molecules/player-sympathy/flex-rank-player-sympathy';
import {getPlayerService} from 'services/sports/factory';
import {splitByCapitalLetter} from 'helpers/string-helper';

class RankPlayersList extends BasePlayersList {
    getSortColumn() {
        const {sportConfig, playersFilter} = this.props;
        const {sortBy} = this.state;

        if (sortBy.col === 'projected_ownership') {
            return (obj) => obj.projOwn.getValue(playersFilter.playersType);
        }

        return getPlayerService(sportConfig).exec('definePropNameOfMode', {
            prop: sortBy.col,
            mode: playersFilter.playersType,
        });
    }

    applyModeToPlayers(players, params = {}) {
        const {modesConfig, playersFilter} = this.props;
        const {isModeApplicableToPlayer = () => true} = params;

        const arr = [];
        if (super.isOverallMode(playersFilter.playersType)) {
            players.map((player) => {
                if (!isModeApplicableToPlayer(player, Const.FLEX_MODE, playersFilter.playersType)) {
                    return;
                }
                if (!player.isExcludedByPoints(Const.FLEX_MODE)) {
                    player.setMode(Const.FLEX_MODE);
                    arr.push({...player});
                }
            });
        } else if (super.isExcludedMode(playersFilter.playersType)) {
            const modes = modesConfig.all({asArr: true});
            modes.map((mode) => {
                players.map((player) => {
                    if (!isModeApplicableToPlayer(player, mode.getRole(), playersFilter.playersType)) {
                        return;
                    }
                    if (player.isExcludedByMode(mode.getRole())) {
                        player.setMode(mode.getRole());
                        arr.push({...player});
                    }
                });
            });
        } else if (super.isLockedMode(playersFilter.playersType)) {
            const modes = modesConfig.all({asArr: true});
            modes.map((mode) => {
                players.map((player) => {
                    if (!isModeApplicableToPlayer(player, mode.getRole(), playersFilter.playersType)) {
                        return;
                    }
                    if (player.isLockedInMode(mode.getRole())) {
                        player.setMode(mode.getRole());
                        arr.push({...player});
                    }
                });
            });
        } else {
            players.map((player) => {
                if (!isModeApplicableToPlayer(player, playersFilter.playersType, playersFilter.playersType)) {
                    return;
                }
                player.setMode(playersFilter.playersType);
                arr.push({...player});
            });
        }

        return arr;
    }

    getPlayersForRendering(params = {}) {
        const {players: rawPlayers} = this.props;

        let players = this.getFilteredPlayers(rawPlayers.all());
        players = this.applyModeToPlayers(players, params);
        players = this.getSortedPlayers(players);

        return [...players];
    }

    getPlayerLockView(params) {
        const {playerId, activeMode, playerMode, className = 'lock-btn'} = params;

        return (
            <PlayerLockByMode
                className={className}
                activeMode={activeMode}
                playerMode={playerMode}
                playerId={playerId}
            />
        );
    }

    getPlayerRankView(params) {
        const {activeMode, playerMode} = params;

        return super.isExcludedMode(activeMode) ? <PlayerRank mode={playerMode} /> : null;
    }

    getPlayerSympathyComponent(params = {}) {
        const {player, activeMode = Const.FLEX_MODE} = params;

        if (this.isOverallMode(activeMode)) {
            const {mode = player.getMode()} = params;

            return <FlexRankPlayerSympathy playerId={player.getId()} mode={mode} />;
        }

        return super.getPlayerSympathyComponent(params);
    }

    getPlayerPointsComponent(params = {}) {
        const {
            player,
            activeMode = Const.FLEX_MODE,
            propName = 'userPoints',
            className = 'form-control small-table-input',
        } = params;

        if (this.isOverallMode(activeMode)) {
            return <FlexRankPlayerPoints className={className} playerId={player.getId()} propName={propName} />;
        }

        return super.getPlayerPointsComponent(params);
    }

    getPlayerMaxExposureComponent(params = {}) {
        const {player, activeMode, inputClassName = 'small-table-input'} = params;

        const mode = this.isOverallMode(activeMode) ? activeMode : player.getMode();
        const propName = 'exposureMax';

        return (
            <PlayerExposure
                className={inputClassName}
                playerId={player.getId()}
                mode={mode}
                propName={propName}
                testId={`${splitByCapitalLetter(propName)}-input`}
            />
        );
    }

    getGeneralMaxExposureComponent(params = {}) {
        const {modesConfig} = this.props;
        const {
            players,
            activeMode,
            outerClassName = 'percent-in',
            inputClassName = 'form-control small-table-input',
        } = params;

        const enabledPlayers = this.getEnabledPlayers(players);

        let modes = [activeMode];
        if (inArray(activeMode, [Const.EXCLUDED_MODE])) {
            modes = modesConfig.all({asArr: true}).map((modeConfig) => modeConfig.getRole());
        }

        return (
            <div className={outerClassName}>
                <GeneralExposure
                    className={inputClassName}
                    players={enabledPlayers}
                    modes={modes}
                    propName={'exposureMax'}
                />
                <span className="percent">%</span>
            </div>
        );
    }

    getModeForProjOwn(activeMode, playerMode) {
        return activeMode === Const.OVERALL_MODE ? activeMode : playerMode;
    }
}

export {RankPlayersList};
